'use client'
import React from 'react'

import packageJson from 'package.json'

export const version = `v.${packageJson.version}`

const VersionInfo = ({ appEnv }: { appEnv: string }) => {
  return (
    <div className="absolute left-0 flex flex-col items-center justify-center font-bold text-caution-070 opacity-70">
      <p className="font-bold">{appEnv}</p>
      <p>{version}</p>
    </div>
  )
}

export default VersionInfo
